import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Não interferir com chamadas ao chatbot (API externa com chave própria)
    if (request.url.includes('/webhook/api')) {
      console.log('🤖 [ApiKeyInterceptor] Chatbot detectado — NÃO adiciono x-api-key do projecto: ' + request.url);
      return next.handle(request);
    }

    // Obter API Key (pode vir do environment ou fallback para valor default seguro para dev)
    // NOTA: Em produção, isto DEVE estar no environment.prod.ts
    const apiKey = (environment as any).apiKey || 'SV_55C572CB722CC296AC7DA63F0F981CC41FA1838CA6F3FB01682AE0280EB289B6';

    // Clonar request para adicionar header
    const authReq = request.clone({
      setHeaders: {
        'x-api-key': apiKey,
      },
    });

    return next.handle(authReq);
  }
}
